import { useEffect, useState } from 'react';
import LoadingPanel from '../../../Abstracts/Components/LoadingPanel';
import useUserApi, { ErrorHandler } from '../../../Services/UserApi';
import EditDepositAccountForm, { EditableEftposDepositAccount, formatBsb } from './EditDepositAccountForm';
import { useHistory, useParams } from 'react-router-dom';
import { BackButton } from '../BreadCrumbs';
import useEftposDepositAccounts from '../../../Hooks/UseEftposDepositAccounts';
import useQuery from '../../../Hooks/UseQuery';

export default function EditDepositAccount() {
	const eftposDepositAccounts = useEftposDepositAccounts();
	const [depositAccount, setDepositAccount] = useState<EditableEftposDepositAccount>();

	const { id: depositAccountId } = useParams<{ id: string }>();

	const query = useQuery();
	const context = query.get('context');

	let backLocation = '/deposit-accounts';
	switch (context) {
		case 'dashboard':
			backLocation = '/';
			break;
		case 'bookings':
			backLocation = `/bookings`;
			break;
		case 'deposit-accounts':
			backLocation = `/deposit-accounts`;
			break;
	}

	useEffect(() => {
		if (!eftposDepositAccounts || !depositAccountId) {
			return;
		}
		const foundMenu = eftposDepositAccounts.find((m) => m.EftposDepositAccountId === parseInt(depositAccountId));
		if (!foundMenu) {
			return;
		}
		setDepositAccount({
			...foundMenu,
			EftposDepositAccountBsb: formatBsb(foundMenu.EftposDepositAccountBsb ?? ''),
		});
	}, [eftposDepositAccounts, depositAccountId]);

	const userApi = useUserApi();
	const history = useHistory();

	const saveDepositAccount = (depositAccount: EditableEftposDepositAccount) => {
		return userApi({
			route: 'eftpos/api',
			data: {
				action: 'saveEftposDepositAccount',
				eftposDepositAccount: depositAccount,
			},
			errorMessage: 'Error saving deposit account',
		})
			.then(() => history.push(backLocation))
			.catch((e: unknown) => ErrorHandler.toast(e));
	};

	if (!eftposDepositAccounts || !depositAccount) {
		return <LoadingPanel />;
	}

	return (
		<>
			<BackButton text="Back" to={backLocation} />
			<EditDepositAccountForm
				depositAccount={depositAccount}
				setDepositAccount={setDepositAccount}
				onSave={saveDepositAccount}
				saveButtonText="Save details"
			/>
		</>
	);
}
